export default {
  lang: 'Sprache',
  currency: 'Währung',
  validGoodUrlFail: 'Dies ist kein korrekter Produktlink',
  product: 'Produkte',
  productHolder: 'Produktname/Link eingeben',
  shop: 'Shop',
  shopHolder: 'Shopname/Shoplink eingeben',
  purchaseAgent: 'Startseite',
  transport: 'Weiterleitung',
  manualOrdering: 'DIY-Bestellung',
  guideBook: 'Anleitung',
  help: 'Hilfe',
  tools: 'Tools',
  customerService: 'Kundenservice',
  purchaseGuide: 'Anleitung zum Startseiteen',
  payment: 'Zahlung',
  delivery: 'Lieferung',
  afterSaleService: 'Kundendienst',
  insuranceCompensation: 'Versicherung und Entschädigung',
  contactInfo: 'Kontaktinformationen',
  enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
  copyRight: 'Copyright©acbuy.com Alle Rechte vorbehalten',
  aboutacbuy: 'Über acbuy',
  contctTime: '9/7 (09:00-18:00, Pekinger Zeit)',
  contactEmail: "Service-E-Mail: Support{'@'}acbuy.com",
  contactMarket: "Marketing-Kooperation: Marketing{'@'}acbuy.com",
  contactCooperation: "Geschäftliche Zusammenarbeit: Business{'@'}acbuy.com",
  tutorial: 'Anleitung',
  serviceFee: 'Servicegebühr',
  orderStatus: 'Leitfaden für Neukunden',
  returnRefunds: 'Rücksendungen und Rückerstattungen',
  topUp: 'Aufladen',
  paypal: 'PayPal',
  internationalCreditCard: 'Internationale Kreditkarte',
  telegraphicTransfer: 'Telegrafische Überweisung',
  charges: 'Gebühren',
  mailRestrictions: 'Versandbeschränkungen',
  customsTaxation: 'Zoll und Steuern',
  receiptInformation: 'Rechnungsinformationen',
  helpCenter: 'Hilfe-Center',
  contactUs: 'Kontaktieren Sie uns',
  registerSuccess: 'Registrierung erfolgreich',
  registerMsg:
    'Wir haben eine Verifizierungs-E-Mail an Ihre E-Mail-Adresse gesendet. Bitte schließen Sie die Verifizierung zeitnah ab, da dies sonst die normale Nutzung Ihrer Punkte beeinträchtigt.',
  continueShopping: 'Weiter einkaufen',
  continueLogin: 'Weiter zur Anmeldung',
  verifyQuestion: 'Haben Sie die Verifizierungs-E-Mail nicht erhalten?',
  verifyResopnseOne:
    '· Die Verifizierungs-E-Mail von acbuy wurde möglicherweise als Spam eingestuft. Bitte überprüfen Sie Ihren Spam-Ordner.',
  verifyResopnseTwo:
    '· Die Zustellung kann sich manchmal um einige Minuten verzögern. Bitte haben Sie Geduld und warten Sie.',
  verifyResopnseThird:
    '· Die Verifizierungs-E-Mail kann sich um einige Minuten verzögern. Wenn Sie die E-Mail nach längerer Zeit nicht erhalten haben, überprüfen Sie, ob sie als Spam markiert wurde, oder senden Sie die Verifizierungs-E-Mail erneut.',
  agentGuide: 'Agentenleitfaden für Neukunden',
  guideBookbtn: 'Handbuch für Anfänger',
  everyonePro: 'Jetzt anmelden und ein Willkommensgeschenk im Wert von 2280 ¥ erhalten!',
  joinAffiliate: 'Jetzt beitreten',
  joinacbuy: 'Treten Sie acbuyDiscord bei, um weitere Vorteile zu erhalten',
  joinDiscord: 'Discord beitreten',
  productPpurchase: 'Produkteinkauf',
  shippingToWarehouse: 'Versand zum Lager',
  qualityAssurance: 'Qualitätssicherung',
  moreCostEffective: 'Kostengünstiger',
  productPpurchaseContent:
    'Produkteinkauf - Sie können problemlos Artikel von TaoBao kaufen. Fügen Sie einfach die TaoBao-Produktlinks auf der acbuy-Website ein und geben Sie eine Bestellung auf. acbuy wird für Sie einkaufen.',
  shippingToWarehouseContent:
    'Versand zum Lager - Kaufen Sie bei verschiedenen Verkäufern mit unserem Service ein, und wir fassen Ihre Bestellungen effizient zusammen. Alle Artikel werden an das von Acbuy angegebene Lager versandt, und wir vereinfachen den Prozess für Ihre Bequemlichkeit.',
  qualityAssuranceContent:
    'Qualitätssicherung - Nachdem Ihre Produkte im von Acbuy angegebenen Lager eingegangen sind, führen wir eine umfassende Qualitätsprüfung Ihrer Produkte durch und senden Ihnen das Inspektionsfeedback, um Ihnen ein besseres Nutzungserlebnis zu bieten.',
  moreCostEffectiveContent:
    'Konzentrierter Transport spart Geld - in Ihrem Lager können Sie Waren frei auswählen und in einem Paket versenden. Mit dem globalen Versandservice von acbuy können Sie die Waren überallhin versenden und einen einfacheren und zuverlässigeren globalen Transport genießen.',
  introduction: 'Auf Taobao über acbuy einkaufen',
  logoIntroduction: 'Shoppen Sie wie ein Millionär.',
  reviewOn: 'Bewertungen',
  productStoragePeriod: 'Lagerdauer für Produkte',
  inspectionRules: 'Prüfungsbestimmungen',
  afterSalesPolicy: 'Kundendienstrichtlinien',
  insuranceAndCompensation: 'Versicherung und Entschädigung',
  oneStopService: 'Komplettservice',
  whatCustomersSay: 'Was unsere Kunden sagen',
  customerSay1:
    'acbuy ist der beste Startseite, den ich je benutzt habe - es ist mein erstes Mal, dass ich acbuy benutze, und seine Produkte sind billiger als bei jedem anderen Startseiteen, was wirklich erstaunlich ist!',
  customerSay2:
    'Nachdem ich acbuy-Promoter wurde, erhielt ich einen Cashback von 300 Yuan. Danach erhalte ich auf jede Bestellung mindestens 4% Cashback.',
  customerSay3:
    'Ein sehr angenehmes Einkaufserlebnis - ich habe acbuy genutzt, um in China einzukaufen, mit qualitativ hochwertigen Produkten, tollem Kundenservice und schnellem Versand.',
  customerSay4:
    'Der beste Agent - der Kauf wurde am selben Tag abgeschlossen. Der Versand des Pakets zu mir nach Hause dauerte nur 7 Tage. Dies ist derzeit der beste Agent.',
  customerFirst: 'Der Kunde zuerst, Premium-Service',
  customerServiceText: '9/7 Online-Kundenservice (09:00-18:00, Pekinger Zeit)',
  faqCategory: 'HÄUFIG GESTELLTE FRAGEN (FAQ)',
  valentine: 'Valentinstags-Überraschungsbox-Freuden',
  joinDiscordNew: 'DISCORD BEITRETEN',
  valentineTip: 'Tritt Discord bei für exklusive Geschenke',
  inviteNow: 'Jetzt einladen',
  comeHere: 'Schalte fantastische Belohnungen frei!',
  viewTutorial: 'Anleitung ansehen',
  springText1: 'So kaufen Sie mit Acbuy auf Taobao ein',
  springText2: 'Freunde einladen & 2000 ¥ Bargeld gewinnen',
  springText3: 'Veranstaltungsdauer: 18. April – 20. Mai',
  category: 'Kategorie',
  hotSale: 'Bestseller',
  motherText1: 'Exklusive Muttertags-Rabatte',
  motherText2: 'Preise gewinnen – Jetzt teilnehmen!',
  motherText3: 'Veranstaltungszeitraum: 30. April – 13. Mai',
  enterNow: 'Jetzt teilnehmen',
  'i18n-000001': 'Bestellungen aufgeben',
  'i18n-000002': 'Fügen Sie einen Artikel-Link ein, um eine Bestellung aufzugeben',
  'i18n-000003': 'Qualitätskontrolle & Lagerung',
  'i18n-000004': '3-5 kostenlose Qualitätskontrollfotos & 90 Tage kostenlose Lagerung',
  'i18n-000005': 'Pakete einreichen',
  'i18n-000006': 'Bündelverpackung & Paketprüfung',
  'i18n-000007': 'Internationaler Versand',
  'i18n-000008': 'Günstigere Linie mit mehr als 150 Versandlinien',
  loveText1: 'Nehmen Sie am 520-Ansturm teil',
  loveText2: 'Große Bestellungen, größere Preise!',
  loveText3: 'Veranstaltungsdauer: 14. Mai – 24. Mai',
  couponResult: 'Es wurden {num} Ergebnisse für „{keyword}“ gefunden.',
  event: 'Veranstaltungen',
}
